
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import i18n from "../../plugins/vue-i18n";
import FileInSettingsComptage from "@/components/comptage/settings/FileInSettingsComptage.vue";
import SelectFilterSettingsComptage from "@/components/comptage/settings/SelectFilterSettingsComptage.vue";
import IComptage from "@/types/comptage.interface";
import IFiltersComptage from "@/types/filters-comptage.interface";


@Component({
    components: {SelectFilterSettingsComptage, FileInSettingsComptage},
})
export default class SettingsComptage extends Vue {

    @Prop() readonly product: IComptage;

    @Prop() readonly preferenceTrigger: boolean;
    @Prop() readonly resetTrigger: boolean;
    @Prop() readonly preferencesComptage: IComptage[];
    @Prop() readonly setFilters!: {};

    tab = 0;
    items = [
        {tab: i18n.tc("comptage.settings.selectfilter"), content: "SelectFilterSettingsComptage"},
        {tab: i18n.tc("comptage.settings.rejectfile"), content: "FileInSettingsComptage"},
    ];

    @Watch("resetTrigger")
    reset() {
      this.tab = 0;
    }
}
